import type { BusinessDefaultProduct, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/default-products';

export function getDefaultProducts(query: BusinessDefaultProduct.SearchQuery) {
    return api.get<Pagination<BusinessDefaultProduct>>(rootPath, query);
}

export function getDefaultProduct(id: number) {
    return api.get<BusinessDefaultProduct.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postDefaultProduct(data: BusinessDefaultProduct.CreateRequest) {
    return api.post<BusinessDefaultProduct>(rootPath, data);
}

export function putDefaultProduct(
    id: number,
    data: BusinessDefaultProduct.UpdateRequest
) {
    return api.put<BusinessDefaultProduct>(`${rootPath}/${id}`, data);
}

export function deleteDefaultProduct({
    id,
}: BusinessDefaultProduct.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
